import { createAction } from 'typesafe-actions';
export const storePushNotification = createAction('@push/STORE', (action) => (n) => action(n));
export const clearPushNotification = createAction('@push/CLEAR');
export const appResumed = createAction('@push/RESUME', (action) => (n) => action(n));
export const refreshUnreadCount = createAction('@push/REFRESH_UNREAD');
export const setUnreadCount = createAction('@push/SET_UNREAD', (action) => (n) => action(n));
export const markOneAsRead = createAction('@push/MARK_AS_READ', (action) => (id) => action(id));
